import React from 'react';
import type { IUserGetTransfersResponse as TransfersDTO } from '@/app-package';
import { TransferState, TransferType } from '@bb/users';
import { capitalize } from 'utils';
import { Tag, Icon } from 'components';

type TagColorMapType = Record<
  TransferState,
  'blue' | 'orange' | 'default' | 'green'
>;

export const processTransferStateName = (state: TransferState) => {
  if (state === TransferState.Active) {
    return 'Accepted';
  }
  return capitalize(state);
};

const transferStatusTagColorMap: TagColorMapType = {
  [TransferState.Pending]: 'orange',
  [TransferState.Active]: 'default',
  [TransferState.Cancelled]: 'default',
  [TransferState.Denied]: 'default',
  [TransferState.Dismissed]: 'default', // Not accessible or displayed to users
};

export const transferTypeTagMap: Record<
  TransfersDTO['transfers'][0]['type'],
  JSX.Element
> = {
  [TransferType.Incoming]: (
    <Tag
      color="default"
      icon={<Icon type="antdArrowLeftOutlined" width={12} height={16} />}
      data-cy-metadata="Incoming Transfer"
    >
      Incoming Transfer
    </Tag>
  ),
  [TransferType.Outgoing]: (
    <Tag
      color="default"
      icon={<Icon type="antdArrowRightOutlined" width={12} height={16} />}
      data-cy-metadata="Outgoing Transfer"
    >
      Outgoing Transfer
    </Tag>
  ),
  [TransferType.New]: (
    <Tag
      color="default"
      icon={<Icon type="plus" width={16} height={16} offset={[-2, 2]} />}
      data-cy-metadata="New Agent"
    >
      New Agent
    </Tag>
  ),
};

export const TransferStatusTag = ({
  state,
  colorOverride = {},
  textProcessor = processTransferStateName,
}: {
  state: TransferState;
  colorOverride?: Partial<TagColorMapType>;
  textProcessor?: (state: TransferState) => string;
}) => {
  const colorMap: TagColorMapType = {
    ...transferStatusTagColorMap,
    ...colorOverride,
  };

  return <Tag color={colorMap[state]}>{textProcessor(state)}</Tag>;
};
